
const LoderSkills = (props) => {
    // console.log(props);

    const skill = props.skills
    // console.log(skill);

    // const subskill = props.subskills
    // console.log(subskill);

    // const progressColor = ['progress-0', 'progress-1', 'progress-2', 'progress-3', 'progress-4'];

    return (
        <div>
            {skill?.map((item, index) =>

                <div className="skillBox" key={item.id}>
                    <div className="block-title" key={item.id}>
                        <h6 className="title" >
                            {item.title}
                        </h6>
                    </div>
                    <div className="skills">
                        <div className="skils-item shimmerBox">
                            <div className="skill-info d-flex justify-content-between">
                                <h4 className="skill-nm"><div className="shine shimmerLine"></div></h4>
                                <div className="skill-value"></div>
                            </div>
                            <div className="progress">
                                <div className="shine shimmerLine"></div>
                            </div>
                        </div>
                        <div className="skils-item shimmerBox">
                            <div className="skill-info d-flex justify-content-between">
                                <h4 className="skill-nm"><div className="shine shimmerLine"></div></h4>
                                <div className="skill-value"></div>
                            </div>
                            <div className="progress">
                                <div className="shine shimmerLine"></div>
                            </div>
                        </div>
                        <div className="skils-item shimmerBox">
                            <div className="skill-info d-flex justify-content-between">
                                <h4 className="skill-nm"><div className="shine shimmerLine"></div></h4>
                                <div className="skill-value"></div>
                            </div>
                            <div className="progress">
                                <div className="shine shimmerLine"></div>
                            </div>
                        </div>
                        <div className="skils-item shimmerBox">
                            <div className="skill-info d-flex justify-content-between">
                                <h4 className="skill-nm"><div className="shine shimmerLine"></div></h4>
                                <div className="skill-value"></div>
                            </div>
                            <div className="progress">
                                <div className="shine shimmerLine"></div>
                            </div>
                        </div>
                    </div>
                </div>
            )
            }
        </div >
    )
}
export default LoderSkills;